import { fabric } from "fabric"
import GroupObject from "../objects/group"
import Calc from "@/common/util/calculator"
import BaseFixmethod from "@/signomatic/app/fixmethods/base"
import RectObject from "@/signomatic/app/objects/rect"

export default class WallProfileFixmethod extends BaseFixmethod {
  get externalTopPadding() {
    return Calc.mmToPx(7)
  }

  get externalBottomPadding() {
    return Calc.mmToPx(7)
  }

  topDrawable() {
    const items = []
    const width = this.state.widthPx
    const height = this.state.heightPx
    const margin = Calc.mmToPx(0.5)
    const heightLight = Calc.mmToPx(2)
    const heightDark = Calc.mmToPx(6)
    const source = this.image()

    if (this.imagesLoaded && source) {
      items.push(
        new RectObject({
          fill: "#cacaca",
          width,
          height: heightLight + Calc.mmToPx(0.2),
          top: margin - Calc.mmToPx(0.2),
        })
      )
      items.push(
        new RectObject({
          fill: "#cacaca",
          width,
          height: heightLight + Calc.mmToPx(0.1),
          top: height - heightLight - margin,
        })
      )

      items.push(
        new RectObject({
          fill: "#d5d5d5",
          width,
          height: heightDark,
          top: margin - heightDark,
        })
      )
      items.push(
        new RectObject({
          fill: "#d5d5d5",
          width,
          height: heightDark,
          top: height - margin,
        })
      )

      const topDark = new RectObject({
        width,
        height: heightDark,
        top: margin - heightDark,
      })
      const bottomDark = new RectObject({ width, height: heightDark, top: height - margin })

      topDark.set(
        "fill",
        new fabric.Pattern({
          source,
          repeat: "repeat-x",
        })
      )

      bottomDark.set(
        "fill",
        new fabric.Pattern({
          source,
          repeat: "repeat-x",
        })
      )

      items.push(topDark)
      items.push(bottomDark)
    }

    return [new GroupObject(items, { left: 0, top: 0, width, height: height + heightLight * 2 })]
  }

  protected imagePaths() {
    return "/images/signomatic/fix_methods/wall_profile.png"
  }
}
